import { StoreInterface } from '../../../../../common/types/interfaces'
import classes from './Item.module.sass'
import { shortenText } from '../../../../../common/utils/functions/shortenText'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import { IconButton } from '../../../../../common/components/iconButton/IconButton'

import edit from '../../../../../assets/images/icons/edit.svg'
import search from '../../../../../assets/images/icons/search.svg'
import { selectClusterImageUrl } from '../../../../../store/slices/currentClusterSlice'

type Props = {
  startEdit: (el: StoreInterface) => void
  el: StoreInterface
  showDetails: (el: StoreInterface) => void
  isConnected: boolean
}

export const ListItem = ({ startEdit, el, showDetails, isConnected }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)
  const imageUrl = useSelector(selectClusterImageUrl)

  return (
    <div className={darkTheme ? classes.containerDark : classes.container}>
      <div className={classes.contentContainer}>
        <img className={classes.image} src={`${imageUrl + el.files[0]}`} alt={el.name} />
        <div className={classes.filesLengthAnchor}>
          <div className={classes.filesLength}>{el.files.length}</div>
        </div>
        <div className={classes.nameAndDescription}>
          <div className={classes.name}>{shortenText(el.name, 50)}</div>
          <div className={classes.description}>{shortenText(el.description, 100)}</div>
        </div>
        <div className={classes.sort}>{el.sortOrder !== 0 ? el.sortOrder : ''}</div>
      </div>
      <div className={classes.buttons}>
        <IconButton
          display
          onClick={() => {
            showDetails(el)
          }}
          icon={search}
          alt="Детали"
          small
        ></IconButton>
        <IconButton
          display
          disabled={!isConnected}
          onClick={() => {
            startEdit(el)
          }}
          icon={edit}
          alt="Изменить"
          small
        ></IconButton>
        {/* <IconButton display onClick={() => {}} icon={trash} alt="Удалить" small></IconButton> */}
      </div>
    </div>
  )
}
